import {call} from 'redux-saga/effects';
import {pAlert} from '../../common/component/PAlert';
import {pToast} from '../../common/container/PToast';
import callApi from '../../common/util/api';
import {API_DEFAULT_LIMIT, IPagingParam} from '../../common/util/fetch';
import {ISearchType} from '../../search/type';

export function* callApiContentLike({
  id,
  isOn,
  isEventPage,
}: {
  id: number;
  isOn: boolean;
  isEventPage?: boolean;
}) {
  const {success, data} = yield call(callApi, {
    url: isOn
      ? '/popularity/v2/subscriptions'
      : '/popularity/v2/subscriptions/unsubscribe',
    method: isOn ? 'POST' : 'DELETE',
    data: isOn ? {contentId: id} : {contentIds: [id]},
  });
  if (success) {
    if (isOn) {
      yield call(
        pAlert,
        isEventPage
          ? {
              title: t => t('crm_fav_notification_popup_title'),
              desc: t => t('crm_fav_notification_popup_content'),
            }
          : {
              title: t => t('contenthome_fav_notification_popup_title'),
              desc: t => t('contenthome_fav_notification_popup_content'),
            }
      );
    } else {
      pToast(t => t('contenthome_fav_undo_toast'));
    }
  }
  return {success, data};
}

export function* callApiSearchResult(
  {keyword, type}: {keyword: string; type?: ISearchType},
  pagingParams: IPagingParam
) {
  const params = new URLSearchParams();
  params.append('limit', String(API_DEFAULT_LIMIT));
  params.append('offset', String(pagingParams.offset));
  params.append(
    'word',
    type === 'keyword' ? keyword.replace('#', '') : keyword
  );

  const {success, data, meta} = yield call(callApi, {
    url: type === 'keyword' ? '/search/v2/keyword' : '/search/v2/content',
    params,
  });
  return {success, data, meta};
}
